import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_facility_doors_exits_stairs_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'are_facility_doors_exits_stairs_line_legal_requirements',
  name: 'Are facility doors, exits and stairs in line with legal requirements?',
  description:
    'This question is to understand if the basic STRUCTURE of doors, exits and stairs are in line with legal requirements. For example, laws might require that doors be a certain width across, and/or that they open outward. ',
  meta: {
    slcpMeta: {
      key: 'hs-8--3',
      number: 'HS-BUI-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-8--3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29440,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
